module.exports = __webpack_public_path__ + "static/media/james1.8a2a2793.mp3";